<!--
 * @Author: pengyong
 * @Date: 2020-11-13 00:50:05
 * @LastEditors: pengyong
 * @LastEditTime: 2020-11-29 14:38:30
 * @Description: 选择身份
 * @FilePath: /exhibit/src/views/role/index.vue
-->
<template>
    <Wrapper :modalWidth="667" :modalHeight="400">
        <div class="role-wrapper">
            <div :class="['item', role === item.role && 'active']" @click="handleClick(item)" v-for="item in items" :key="item.title">
                <h1>{{ item.title }}</h1>
                <p>{{ item.text }}</p>
                <div class="img"></div>
            </div>
        </div>
    </Wrapper>
</template>

<script>
import Wrapper from "@/components/CommonWrapper";
export default {
    components: {
        Wrapper
    },
    data() {
        return {
            role: ""
        };
    },
    computed: {
        items() {
            return [
                {
                    title: this.$t("role").gzTitle,
                    // text: this.$t("role").gzDesc,
                    role: "audience"
                },
                {
                    title: this.$t("role").zsTitle,
                    // text: this.$t("role").zsDesc,
                    role: "exhibiter"
                }
            ];
        }
    },
    methods: {
        handleClick(item) {
            const { role } = item;
            if (role == "exhibiter") {
                let language = localStorage.getItem("language") || "zh"
                window.location.href = `https://sso.cloudvhall.com/#/?redirect=https%3A%2F%2Fmanage.cloudvhall.com%2Fexhibitor%2F&paas=shidai&language=${language}`;
                return;
                console.log(language)
            }
            this.role = role;
            localStorage.setItem("role", role);
            this.$router.push(`/login?role=${role}`);
        }
    }
};
</script>

<style lang="scss" scoped>
.role-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    width: 100%;
    height: 100%;
    .item {
        width: 240px;
        height: 133px;
        border-radius: 13px;
        background: rgba(9, 70, 140, 0.1);
        box-shadow: 1px 3px 4px 0px rgba(0, 0, 0, 0.2), -1px -3px 4px 0px rgba(255, 255, 255, 0.4);
        position: relative;
        padding-top: 33px;
        cursor: pointer;
        color: #5f7185;
        overflow: hidden;
        transition: all 0.2s;
        color: rgba(9, 70, 140, 1);
        &:hover {
            transform: scale(1.1);
        }
        .img {
            position: absolute;
            right: 0;
            bottom: 0;
        }
        &:first-of-type {
            margin-right: 4.17%;
            .img {
                width: 86px;
                height: 66px;
                background: url("~@/assets/guanzhong.png") no-repeat center;
                background-size: cover;
                right: -1px;
                bottom: -1px;
            }
        }
        &:last-of-type {
            .img {
                width: 67px;
                height: 68px;
                background: url("~@/assets/zhanshang.png") no-repeat center;
                background-size: cover;
            }
        }
        h1 {
            height: 28px;
            font-size: 20px;
            line-height: 70px;
            font-weight: 600;
            margin-bottom: 11px;
        }
        p {
            height: 15px;
            font-size: 11px;
            line-height: 15px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/role/index.vue